export type Tone = "red" | "yellow" | "green" | "blue" | "purple";

export interface Killer {
  n: string;
  title: string;
  cost: string;
  fix: string;
}

export interface Win {
  title: string;
  body: string;
}

export interface ScorecardLens {
  lens: string;
  score: number;
}

export interface Gauge {
  key: "SEO" | "GEO";
  label: string;
  score: number;
  note: string;
}

export interface QuestDay {
  day: string;
  task: string;
  tag: "Quick win" | "Heavier lift";
}

export interface Report {
  url: string;
  said?: string;
  saw: string;
  score: number;
  verdict: string;
  killers: [Killer, Killer, Killer];
  wins: [Win, Win, Win];
  scorecard: [
    ScorecardLens,
    ScorecardLens,
    ScorecardLens,
    ScorecardLens,
    ScorecardLens,
    ScorecardLens
  ];
  gauges: [Gauge, Gauge];
  sevenDays: [
    QuestDay,
    QuestDay,
    QuestDay,
    QuestDay,
    QuestDay,
    QuestDay,
    QuestDay
  ];
  oneSentence: string;
}

export const SCORECARD_LENSES = [
  "First impression",
  "Buyer clarity",
  "Message match",
  "Trust and credibility",
  "Pricing transparency",
  "Technical and performance"
] as const;

export type ScoreBand = "Stop." | "Not yet." | "Close." | "Ship it.";

export function scoreBand(score: number): { word: ScoreBand; note: string } {
  if (score < 50) return { word: "Stop.", note: "You'll burn early goodwill and learn the wrong lessons." };
  if (score < 70) return { word: "Not yet.", note: "Real gaps that will waste your traffic." };
  if (score < 85) return { word: "Close.", note: "Fix the red items first, then go." };
  return { word: "Ship it.", note: "Polish in flight." };
}
